import React from 'react';
import AdmissionInfo from '../components/AdmissionInfo';
import Footer from '../components/Footer';

function Admission() {
  return (
    <>
      <AdmissionInfo />
      <Footer />
    </>
  );
}

export default Admission;
